import React from "react";
import Loadable from "../../react-loadable";

const WeaAudio = Loadable({
  loader: () => import("./Audio"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaAudio;



// WEBPACK FOOTER //
// ./ecology9/wea-audio/index.js